<script setup lang="ts"></script>

<template>
  <header>
    <div class="container-fluid d-flex justify-content-center align-items-center">
      <h1>{{ $t("nav.title") }}</h1>
    </div>
  </header>
</template>

<style scoped>
header {
  height: var(--header-height);
  border-bottom: 1px solid lightgray;
}

.container-fluid {
  height: 100%;
  padding-left: var(--container-padding);
  padding-right: var(--container-padding);
}

h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}
</style>
